module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-400-regular-italic-54a3f1fe9fd86dd4dc689fe28d8e5bd1.woff";